import { defineStore } from 'pinia'
import { computed, reactive } from 'vue'

const useDictStore = defineStore('dict', () => {
  const state = reactive({
    dict: [],
    dictObj: {
      label: {},
    },
  })

  const getDict = (key) => {
    if (!key) {
      return null
    }
    return state.dict.find((item) => item.key === key)?.value || null
  }

  const setDict = (key, value) => {
    if (!key) {
      return
    }

    const dictValue = Array.isArray(value) ? value : []
    const dictIndex = state.dict.findIndex((item) => item.key === key)
    const dictItem = {
      key,
      value: dictValue,
    }

    if (dictIndex > -1) {
      state.dict.splice(dictIndex, 1, dictItem)
    } else {
      state.dict.push(dictItem)
    }

    state.dictObj[key] = dictValue
    state.dictObj.label[key] = {}
    dictValue.forEach((item) => {
      state.dictObj.label[key][item.value] = item.label
    })
  }

  const removeDict = (key) => {
    if (!key) {
      return false
    }

    const dictIndex = state.dict.findIndex((item) => item.key === key)
    if (dictIndex > -1) {
      state.dict.splice(dictIndex, 1)
    }
    delete state.dictObj[key]
    delete state.dictObj.label[key]
    return dictIndex > -1
  }

  const cleanDict = () => {
    state.dict = []
    state.dictObj = {
      label: {},
    }
  }

  return {
    state,
    dict: computed(() => state.dict),
    dictObj: computed(() => state.dictObj),
    getDict,
    setDict,
    removeDict,
    cleanDict,
  }
})

export default useDictStore
